import { Skeleton } from "@/components/ui/skeleton";

export function BuildReviewSkeleton() {
  const laneLabels = [
    "Build Review Required",
    "On Hold — Sales Action Required",
    "Resubmitted for Review",
    "Revision Required",
    "Awaiting Sales Confirmation",
    "Awaiting Customer Signature",
    "Final Build Review",
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2.5">
        <Skeleton className="h-5 w-5" />
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-4 w-24" />
      </div>

      {laneLabels.map((label, laneIdx) => (
        <div key={laneIdx} className="space-y-2">
          <div className="flex items-center gap-2 px-0.5">
            <Skeleton className="h-4 w-4" />
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-12" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
            {Array.from({ length: laneIdx === 0 || laneIdx === 4 ? 3 : 2 }).map((_, cardIdx) => (
              <div key={cardIdx} className="border rounded-lg bg-card p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-5 w-24 rounded-full" />
                </div>

                <div className="flex items-center gap-3">
                  <Skeleton className="h-3 w-28" />
                  <div className="flex items-center gap-2 ml-auto">
                    <Skeleton className="h-3 w-10" />
                    <Skeleton className="h-3 w-8" />
                  </div>
                </div>

                {(laneIdx === 1 || laneIdx === 3) && (
                  <div className="space-y-1">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-3 w-full" />
                  </div>
                )}

                <div className="flex items-center gap-2 pt-1">
                  <Skeleton className="h-7 w-32" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}